import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import CreateWizard from "./CreateWizard";
export default function CreatePage() {
    return (_jsx("div", { className: "container-fluid", children: _jsxs("article", { id: "create-wizard", className: "article", children: [_jsx("h2", { className: "article-title", children: "New Delivery" }), _jsx(CreateWizard, {}), _jsx("div", { children: "\u00A0" })] }) }));
}
